module.exports = __webpack_public_path__ + "static/media/day-loading.92feaeeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/day-loading.png
// module id = 203
// module chunks = 0